import React, {useEffect, useMemo} from 'react'
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {range} from "lodash";

const TablePagination = (props) => {
  const {t} = useTranslation();

  const {pages, current, last} = useMemo(() => {
    const last = Math.floor(props.total / props.pageSize) - (props.total % props.pageSize === 0 ? 1 : 0);
    const current = props.page;

    const left = Math.max(0, current - 2 + (current + 2 > last ? last - current - 2 : 0));
    const right = Math.min(last, current + 2 + (current - 2 < 0 ? 2 - current : 0));

    let pages = range(left, right + 1).map(page => ({number: page, active: page === current}));
    if (last > 4) {
      pages[0].after = left > 0;
      pages[0].number = left > 0 ? 0 : left;
      pages[pages.length - 1].before = right < last;
      pages[pages.length - 1].number = right < last ? last : right;
    }
    return {pages: pages, current: current, last: last};
  }, [props.page, props.pageSize, props.total])

  function onPageClick(event) {
    const number = Math.max(0, Math.min(parseInt(event.target.dataset.number), last));
    props.onPage && props.onPage(number);
  }

  if (isNaN(props.page) || isNaN(props.pageSize) || isNaN(props.total)) {
    return null;
  }

  return (
    <nav className={"pagination is-rounded is-small is-centered " + (props.className ? props.className : "")} role="navigation" aria-label="pagination">
      <a className={current <= 0 ? "pagination-previous is-disabled" : "pagination-previous"} data-number={current - 1} onClick={onPageClick}>{t("Previous page")}</a>
      <ul className="pagination-list">
        {
          pages.map(({number, active, before, after, disabled}) =>
            <React.Fragment key={number}>
              {
                !!before &&
                <li><span className="pagination-ellipsis">&hellip;</span></li>
              }
              <li>
                <a className={(active ? "pagination-link is-current" : "pagination-link") + (last === 0 || disabled ? " is-disabled" : "")}
                   aria-label={"Goto page " + (number + 1)} data-number={number} onClick={onPageClick}>{number + 1}</a>
              </li>
              {
                !!after &&
                <li><span className="pagination-ellipsis">&hellip;</span></li>
              }
            </React.Fragment>
          )
        }
      </ul>
      <a className={current >= last ? "pagination-next is-disabled" : "pagination-next"} data-number={current + 1} onClick={onPageClick}>{t("Next page")}</a>
    </nav>
  );
}

TablePagination.propTypes = {
  page: PropTypes.number,
  pageSize: PropTypes.number,
  total: PropTypes.number,
  onPage: PropTypes.func,
  className: PropTypes.string,
};


export default TablePagination
